import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Text } from '@qga/roo-ui/components';
import { FEATURED_PROPERTY_SOURCES } from 'lib/enums/property';

const OfferHighlighterWrapper = styled(Box)`
  border-radius: 0 0 0 ${themeGet('radii.default')};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${themeGet('zIndices.highlightBorder')};
    border: 2px solid ${(props) => themeGet(props.highlightColor)};
    border-top-width: 0;
    pointer-events: none;
  }
`;

const UppercaseText = styled(Text)`
  text-transform: uppercase;
`;

const OfferHighlighter = ({ children }) => {
  const { color, background } = FEATURED_PROPERTY_SOURCES.DEFAULT;

  return (
    <Fragment>
      <Box data-testid="offer-highlighter" bg={background} py="2" px={[4, 5]} borderRadius="defaultRoundTopOnly">
        <UppercaseText fontSize="base" fontWeight="bold" color={color}>
          You picked this deal
        </UppercaseText>
      </Box>
      <OfferHighlighterWrapper highlightColor={`colors.${background}`}>{children}</OfferHighlighterWrapper>
    </Fragment>
  );
};

OfferHighlighter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OfferHighlighter;
